module.exports = __webpack_public_path__ + "static/5-hildur-fb01b1cbcec58c0c6edd6a67e7dc8f3a.jpg";